var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigCoin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 626.156,
    height: 476.109,
    viewBox: "0 0 626.156 476.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16456",
    "data-name": "Rectangle 16456",
    width: 356.184,
    height: 423.486,
    fill: "none",
    stroke: "#1228f3",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16458",
    "data-name": "Rectangle 16458",
    width: 213.859,
    height: 127.078,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_65328",
    x: 0,
    y: 168.165,
    width: 73.722,
    height: 73.633,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3c4ef5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_34558",
    x: 476.606,
    y: 237.288,
    width: 114.233,
    height: 114.144,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3c4ef5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_65329",
    x: 552.434,
    y: 132.849,
    width: 73.722,
    height: 73.633,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3c4ef5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gig_coin",
    "data-name": "gig coin",
    transform: "translate(-1162.548 -2862.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coin_1920",
    "data-name": "coin 1920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45477",
    "data-name": "Group 45477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45144",
    "data-name": "Group 45144",
    transform: "translate(1290.165 2862.445)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88637",
    "data-name": "Path 88637",
    d: "M264.418,259.583C217.4,343.71,172.89,418.07,114.287,415.707c-13.088-.527-53.94-25.626-65.139-31.887-61.371-34.3-64.488-145.539-6.966-248.454S196.086-23.171,257.457,11.132c9.283,5.189,44.039,19.928,50.648,28.346,37.074,47.216,5.133,132.763-43.688,220.106",
    transform: "translate(0.938 0.938)",
    fill: "#fecf45",
    stroke: "#1228f3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88638",
    "data-name": "Path 88638",
    d: "M264.418,259.583C217.4,343.71,172.89,418.07,114.287,415.707c-13.088-.527-53.94-25.626-65.139-31.887-61.371-34.3-64.488-145.539-6.966-248.454S196.086-23.171,257.457,11.132c9.283,5.189,44.039,19.928,50.648,28.346C345.18,86.693,313.238,172.241,264.418,259.583Z",
    transform: "translate(0.938 0.938)",
    fill: "none",
    stroke: "#1228f3",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88639",
    "data-name": "Path 88639",
    d: "M286.754,272.047C229.23,374.962,133.894,431.168,73.812,397.586S11.656,253.35,69.179,150.435,222.041-8.685,282.121,24.9s62.156,144.234,4.633,247.149",
    transform: "translate(25.67 14.239)",
    fill: "#fef500",
    stroke: "#1228f3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88640",
    "data-name": "Path 88640",
    d: "M286.754,272.047C229.23,374.962,133.894,431.168,73.812,397.586S11.656,253.35,69.179,150.435,222.041-8.685,282.121,24.9,344.277,169.132,286.754,272.047Z",
    transform: "translate(25.67 14.239)",
    fill: "none",
    stroke: "#1228f3",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95277",
    "data-name": "Path 95277",
    d: "M241.735,229.667C194.194,315.6,115.4,362.536,65.75,334.495s-51.369-120.44-3.829-206.375S188.253-4.749,237.906,23.294s51.369,120.438,3.829,206.374",
    transform: "translate(53.1 46.586)",
    fill: "#efbd2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45146",
    "data-name": "Group 45146",
    transform: "translate(1395.217 3211.476)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45145",
    "data-name": "Group 45145",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88641",
    "data-name": "Path 88641",
    d: "M8.39,74.723A12.816,12.816,0,0,0,13.8,75.753c.692-1.663,2.487-5.828,2.487-5.828L10.426,67.59a12,12,0,0,1,1.115-2.62c1.307.287,8.967,3.171,8.954,3.574-.062.793-3.415,8.124-4.534,10.294a16.67,16.67,0,0,1-9.077-1.254C-.354,74.394-1.5,67.417,1.659,60.247c2.948-6.693,9.6-10.357,16.67-7.242a14.28,14.28,0,0,1,6.4,5.195,9.47,9.47,0,0,1-2.569,2.022A12.345,12.345,0,0,0,17,56.023c-4.631-2.04-9.76.579-12.041,5.759-2.54,5.762-1.472,10.78,3.433,12.942",
    transform: "translate(0 43.117)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88642",
    "data-name": "Path 88642",
    d: "M30.734,69.572c-.537,5.035-3.933,8.6-9.54,8.112-5-.531-8.287-4.351-7.667-10.206.482-4.514,4.012-8.628,9.531-8.038,4.962.527,8.32,4.052,7.676,10.133m-7.945-6.881c-3.69-.43-5.678,1.961-6.032,5.281-.443,4.177,1.811,6.378,4.645,6.68,3.615.423,5.682-1.622,6.092-5.5.485-4.55-1.875-6.121-4.706-6.46",
    transform: "translate(11.18 49.351)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88643",
    "data-name": "Path 88643",
    d: "M36.892,73.572c.273,1.7,1.058,2.792,2.878,2.538,1.893-.269,2.93-1.613,3.263-1.668.4.126,1.28,1.807,1.388,2.245a7.652,7.652,0,0,1-4.772,2.443c-3.6.542-5.473-1.434-5.944-4.587-.256-2.047-1.144-10.148-1.152-10.183s-3.234.445-3.435.364c-.167-.088-.734-2.426-.383-2.6.143-.06,3.312-.419,3.411-.513s-.668-4.147-.39-4.534a6.978,6.978,0,0,1,3.032-.754c.214.154.566,4.922.641,4.911.068-.051,5.546-.934,5.966-.7.381.242.436,2.472.436,2.472-.222.266-6.125.877-6.1,1.025.018.112.8,6.823,1.161,9.536",
    transform: "translate(23.788 46.786)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88644",
    "data-name": "Path 88644",
    d: "M54.89,63.325c1.489,4.84-.231,9.45-5.574,11.213-4.8,1.48-9.333-.738-11.065-6.365-1.337-4.34.289-9.509,5.6-11.142,4.768-1.469,9.243.45,11.043,6.293m-10.012-3.2c-3.558,1.057-4.448,4.038-3.464,7.227,1.236,4.016,4.177,5.153,6.9,4.314,3.488-1.036,4.583-3.726,3.435-7.456-1.346-4.373-4.135-4.887-6.87-4.085",
    transform: "translate(31.42 47.004)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88645",
    "data-name": "Path 88645",
    d: "M52.091,46.954c.428.295,10.7,23.112,11.732,25.736a14.577,14.577,0,0,1-2.538,1.033c-.37-.075-12.023-24.853-11.64-25.448.264-.5,2.234-1.511,2.446-1.32",
    transform: "translate(41.25 39.002)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88646",
    "data-name": "Path 88646",
    d: "M54.948,46.383a2.357,2.357,0,0,1,3.38,1.183,2.208,2.208,0,0,1-1.192,2.961,2.128,2.128,0,0,1-3.107-.9c-.665-1.26-.773-2.347.919-3.239m5.519,6.923c.168.081,8.267,15.436,8.289,15.72a7.858,7.858,0,0,1-2.6,1.415c-.082-.082-8.546-15.161-8.54-15.632a9.38,9.38,0,0,1,2.855-1.5",
    transform: "translate(44.527 38.28)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88647",
    "data-name": "Path 88647",
    d: "M70.786,60.136c.888,1.481,2.022,2.2,3.616,1.285,1.659-.95,2.122-2.585,2.412-2.759.419-.031,1.86,1.2,2.122,1.569a7.645,7.645,0,0,1-3.523,4.041c-3.14,1.84-5.616.7-7.225-2.051-1-1.809-4.834-9-4.851-9.031s-2.838,1.615-3.056,1.617c-.187-.02-1.584-1.981-1.32-2.271.11-.11,2.921-1.622,2.979-1.747s-2.164-3.6-2.047-4.063A6.972,6.972,0,0,1,62.427,44.9c.256.064,2.355,4.362,2.419,4.321.046-.07,4.8-2.928,5.281-2.862.445.082,1.326,2.135,1.326,2.135-.108.326-5.363,3.087-5.286,3.215.059.1,3.276,6.041,4.62,8.427",
    transform: "translate(48.974 37.312)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88648",
    "data-name": "Path 88648",
    d: "M80.283,55.244a7.272,7.272,0,0,0,3.091-4.411,7.174,7.174,0,0,1,2.474,1.241,10,10,0,0,1-4.006,5.653c-4.6,3.232-9.379,1.586-12.138-2.344-2.822-4.023-2.906-9.371,1.516-12.471a7.21,7.21,0,0,1,10.289,1.67A9.863,9.863,0,0,1,82.77,46.9c-1.344,1.218-7.76,5.72-10.016,7.209a5.252,5.252,0,0,0,7.529,1.132M79.03,46.731c-1.58-2.646-4.072-3.19-6.407-1.555a4.869,4.869,0,0,0-1.113,6.967Z",
    transform: "translate(56.279 34.458)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88649",
    "data-name": "Path 88649",
    d: "M97.083,34.931c3.622,4.155,3.536,8.908-.317,12.367-1.979,1.723-4.365,2.41-6.026,1.818C93.2,51.943,97.576,56.788,97.561,57a8.179,8.179,0,0,1-2.443,2.28c-.051,0-16.657-19.115-16.965-20.041a26.24,26.24,0,0,1,2.382-1.829c.447.509,1.238,1.36,1.7,1.9-.317-1.562.319-3.858,2.58-5.83,3.565-3.106,8.271-3.127,12.263,1.454M86.516,36.278c-2.77,2.415-2.543,5.3-.227,7.96,2.736,3.138,5.988,2.988,8.137,1.117,2.686-2.34,2.516-5.277.027-8.132-2.908-3.338-5.731-2.867-7.938-.945",
    transform: "translate(64.951 26.009)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88650",
    "data-name": "Path 88650",
    d: "M90.3,26.764c3.459-3.437,7.222-3.159,11.03.67,2.51,2.527,6.6,6.916,6.658,7.128.079.24-1.941,1.93-1.941,1.93l-1.3-1.04a6.85,6.85,0,0,1-2.164,4.953c-3.27,3.252-6.557,2.71-8.54.716-2.538-2.553-2.047-6.264.745-9.04A6.2,6.2,0,0,1,99.227,30c-2.644-2.661-4.47-3.331-7.024-.793-2.34,2.327-1.419,4.424-1.608,4.715a5.655,5.655,0,0,1-2.52.337c-.4-.61-.967-4.323,2.225-7.5m11.074,11.463c1.968-1.954,1.9-4.157.707-5.354-1.507-1.514-3.655-1.071-5.438.7-1.756,1.745-1.868,4.025-.547,5.354,1.375,1.384,3.523,1.046,5.279-.7",
    transform: "translate(72.938 20.247)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88651",
    "data-name": "Path 88651",
    d: "M112.063,18.52c4.111,3.675,4.614,8.4,1.219,12.312-1.751,1.959-4.034,2.937-5.757,2.554,2.8,2.5,7.74,6.768,7.751,6.978a8.257,8.257,0,0,1-2.141,2.565c-.055,0-18.908-16.9-19.329-17.783a26.14,26.14,0,0,1,2.141-2.113c.5.45,1.4,1.2,1.928,1.674-.511-1.514-.165-3.873,1.837-6.108,3.149-3.525,7.819-4.131,12.351-.079m-10.322,2.648c-2.45,2.741-1.868,5.579.764,7.929,3.1,2.778,6.314,2.225,8.214.1,2.377-2.655,1.842-5.548-.983-8.075-3.3-2.952-6.044-2.133-7.994.048",
    transform: "translate(77.96 13.058)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88652",
    "data-name": "Path 88652",
    d: "M116.983,19.824a7.269,7.269,0,0,0,1.721-5.105,7.236,7.236,0,0,1,2.725.5,10.009,10.009,0,0,1-2.254,6.548c-3.507,4.4-8.549,4.164-12.3,1.17-3.838-3.063-5.427-8.167-2.06-12.389a7.21,7.21,0,0,1,10.34-1.295,9.869,9.869,0,0,1,1.864,1.871c-.945,1.547-5.834,7.672-7.575,9.736a5.252,5.252,0,0,0,7.54-1.033m-3.6-7.815c-2.261-2.093-4.8-1.913-6.581.313a4.864,4.864,0,0,0,.894,7Z",
    transform: "translate(85.578 6.34)",
    fill: "#112df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88653",
    "data-name": "Path 88653",
    d: "M116.145,2.408A16.748,16.748,0,0,0,114.581,4.1a4.4,4.4,0,0,0,.48,5.319c.359.4,8.992,6.385,9.04,6.513a10.245,10.245,0,0,1-1.99,2.725c-.167-.029-13.523-9.787-14.054-10.267-.374-.507,1.143-2.836,1.494-2.811a21.336,21.336,0,0,1,2.21,1.615,6.549,6.549,0,0,1,1.811-7.18c.341-.214,2.5,1.732,2.573,2.391",
    transform: "translate(89.754 0)",
    fill: "#112df5"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1162.55, 2862.45)",
    filter: "url(#Path_65328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65328-2",
    "data-name": "Path 65328",
    d: "M70.634,35.317C40.363,38.1,38.1,40.362,35.318,70.633,32.531,40.362,30.272,38.1,0,35.317,30.272,32.531,32.531,30.271,35.318,0,38.1,30.271,40.363,32.531,70.634,35.317",
    transform: "translate(1 169.17)",
    fill: "#fff",
    stroke: "#c2c7fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1162.55, 2862.45)",
    filter: "url(#Path_34558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34558-2",
    "data-name": "Path 34558",
    d: "M111.145,55.572c-47.633,4.385-51.188,7.939-55.572,55.572C51.188,63.511,47.634,59.957,0,55.572,47.634,51.188,51.188,47.633,55.573,0c4.384,47.633,7.939,51.188,55.572,55.572",
    transform: "translate(477.61 238.29)",
    fill: "#fff",
    stroke: "#c2c7fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1162.55, 2862.45)",
    filter: "url(#Path_65329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65329-2",
    "data-name": "Path 65329",
    d: "M70.634,35.317C40.363,38.1,38.1,40.362,35.318,70.633,32.531,40.362,30.272,38.1,0,35.317,30.272,32.531,32.531,30.271,35.318,0,38.1,30.271,40.363,32.531,70.634,35.317",
    transform: "translate(553.43 133.85)",
    fill: "#fff",
    stroke: "#c2c7fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45829",
    "data-name": "Group 45829",
    transform: "translate(1290.165 2862.445)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95278",
    "data-name": "Path 95278",
    d: "M264.418,259.583C217.4,343.71,172.89,418.07,114.287,415.707c-13.088-.527-53.94-25.626-65.139-31.887-61.371-34.3-64.488-145.539-6.966-248.454S196.086-23.171,257.457,11.132c9.283,5.189,44.039,19.928,50.648,28.346,37.074,47.216,5.133,132.763-43.688,220.106",
    transform: "translate(0.938 0.938)",
    fill: "#fecf45",
    stroke: "#1228f3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95279",
    "data-name": "Path 95279",
    d: "M264.418,259.583C217.4,343.71,172.89,418.07,114.287,415.707c-13.088-.527-53.94-25.626-65.139-31.887-61.371-34.3-64.488-145.539-6.966-248.454S196.086-23.171,257.457,11.132c9.283,5.189,44.039,19.928,50.648,28.346C345.18,86.693,313.238,172.241,264.418,259.583Z",
    transform: "translate(0.938 0.938)",
    fill: "none",
    stroke: "#1228f3",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95280",
    "data-name": "Path 95280",
    d: "M286.754,272.047C229.23,374.962,133.894,431.168,73.812,397.586S11.656,253.35,69.179,150.435,222.041-8.685,282.121,24.9s62.156,144.234,4.633,247.149",
    transform: "translate(25.67 14.239)",
    fill: "#fef500",
    stroke: "#1228f3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95281",
    "data-name": "Path 95281",
    d: "M286.754,272.047C229.23,374.962,133.894,431.168,73.812,397.586S11.656,253.35,69.179,150.435,222.041-8.685,282.121,24.9,344.277,169.132,286.754,272.047Z",
    transform: "translate(25.67 14.239)",
    fill: "none",
    stroke: "#1228f3",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95282",
    "data-name": "Path 95282",
    d: "M241.735,229.667C194.194,315.6,115.4,362.536,65.75,334.495s-51.369-120.44-3.829-206.375S188.253-4.749,237.906,23.294s51.369,120.438,3.829,206.374",
    transform: "translate(53.1 46.586)",
    fill: "#efbd2b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_95283",
    "data-name": "Path 95283",
    d: "M135.884,25.828c-.183,8.186.691,15.174,4.093,19.438l-109.1,63.826h0c-4.2,2.477-7.609.594-7.6-4.216l.151-27.458v0A17.027,17.027,0,0,1,31.177,64.2L141,.894A64.056,64.056,0,0,0,135.884,25.828ZM.878,140.248,111.013,75.529h0c4.061-2.4,7.284-.514,7.2,4.21l-.532,26.714v0a16.993,16.993,0,0,1-7.5,12.818L.79,184.488A60.863,60.863,0,0,0,5.645,159.6l0,0C5.664,151.423,4.591,144.445.878,140.248Zm21.916,52.868c.042-4.706,3.452-10.533,7.611-13.005l107.949-64.628a61.992,61.992,0,0,0-5.024,24.231c-.177,7.908.685,14.623,4.034,18.631l-107.247,65.1h0c-4.132,2.524-7.477.816-7.467-3.826l.146-26.5Z",
    transform: "translate(1426.104 2967.783)",
    fill: "#fef500",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1127",
    "data-name": "Line 1127",
    x2: 50.533,
    y2: 25.267,
    transform: "translate(1503.409 2866.171)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1128",
    "data-name": "Line 1128",
    x2: 51.796,
    y2: 26.53,
    transform: "translate(1474.353 2869.961)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1129",
    "data-name": "Line 1129",
    x2: 49.901,
    y2: 25.267,
    transform: "translate(1448.454 2881.331)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1130",
    "data-name": "Line 1130",
    x2: 51.796,
    y2: 26.53,
    transform: "translate(1422.556 2896.491)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1131",
    "data-name": "Line 1131",
    x2: 50.684,
    y2: 26.059,
    transform: "translate(1399.816 2915.441)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1132",
    "data-name": "Line 1132",
    x2: 51.796,
    y2: 26.53,
    transform: "translate(1375.813 2939.444)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1133",
    "data-name": "Line 1133",
    x2: 50.35,
    y2: 25.736,
    transform: "translate(1353.15 2969.764)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1134",
    "data-name": "Line 1134",
    x2: 50.563,
    y2: 26.569,
    transform: "translate(1332.938 3000.931)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1135",
    "data-name": "Line 1135",
    x2: 51.796,
    y2: 26.53,
    transform: "translate(1315.251 3037.567)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1136",
    "data-name": "Line 1136",
    x2: 50.611,
    y2: 26.113,
    transform: "translate(1302.54 3074.62)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1147",
    "data-name": "Line 1147",
    x2: 49.27,
    y2: 25.267,
    transform: "translate(1295.708 3113.133)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1148",
    "data-name": "Line 1148",
    x2: 47.967,
    y2: 23.82,
    transform: "translate(1293.182 3153.56)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1149",
    "data-name": "Line 1149",
    x2: 46.743,
    y2: 22.74,
    transform: "translate(1300.762 3195.25)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCoin);
export default __webpack_public_path__ + "static/media/big-coin.5d5080a1f762cc96104efa464ecc58b0.svg";
export { ForwardRef as ReactComponent };